export const ZOOM_DURATION_MIN = 250;
export const ZOOM_DURATION_MAX = 900;
export const ZOOM_DURATION_PER_UNIT = 120;

export function calculateSemanticZoomDuration(fromZoom: number, toZoom: number): number {
    const distance = Math.abs(toZoom - fromZoom);
    const raw = ZOOM_DURATION_MIN + distance * ZOOM_DURATION_PER_UNIT;
    return Math.min(Math.max(raw, ZOOM_DURATION_MIN), ZOOM_DURATION_MAX);
}
